import { render, staticRenderFns } from "./DriverInfoTable.vue?vue&type=template&id=0029cb52&scoped=true"
import script from "./DriverInfoTable.vue?vue&type=script&lang=js"
export * from "./DriverInfoTable.vue?vue&type=script&lang=js"
import style0 from "./DriverInfoTable.vue?vue&type=style&index=0&id=0029cb52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029cb52",
  null
  
)

export default component.exports